import React from "react";
import { motion } from "framer-motion";
import {
  Monitor,
  Users,
  TrendingUp,
  ArrowUpCircle,
  Link2,
  Heart,
  type LucideIcon,
} from "lucide-react";

type BenefitItem = {
  title: string;
  text: string;
  icon: LucideIcon;
};

const benefits: BenefitItem[] = [
  {
    title: "Start a New",
    text: "Website redesigning gives you the chance to start over new and correct the mistakes that you might have made when you started the website years back.",
    icon: Monitor,
  },
  {
    title: "Wider Audience",
    text: "The digital world is moving at an extremely fast pace and if you want to survive in the race to be better than the rest, you need to adapt.",
    icon: Users,
  },
  {
    title: "Increase Conversion Rates",
    text: "The conversion rate of a website is effective for business profit. If your conversion rate is down, there might be many reasons for this such as navigation issues.",
    icon: TrendingUp,
  },
  {
    title: "Get Better Ranking",
    text: "A new website will also help you in getting better search engine rankings and reach the top 10. Not only do we redesign your website with new content but also make sure that it is optimized for search engines.",
    icon: ArrowUpCircle,
  },
  {
    title: "Reinforce Your Brand",
    text: "The redesigning of your website will also offer the chance of bringing changes to your brand image. The entire interface of the website can also be changed to make it more gripping and easily usable.",
    icon: Link2,
  },
  {
    title: "Boosts Morale",
    text: "A new website will not only delight your customers but also your employees. The new look and feel of the website will instill a sense of direction and make them work harder and better.",
    icon: Heart,
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 },
};

const WredBenefitsSection: React.FC = () => (
  <section className="wred-benefits-section" aria-labelledby="wred-benefits-title">
    <div className="wredesign-container">
      <div className="wred-benefits-panel">
        <div className="wred-benefits-panel__head">
          <h2 id="wred-benefits-title">Benefits of Website Redesigning</h2>
          <p>
            Redesigning your website helps you stay competitive, reach a wider audience, and
            deliver a modern experience that converts visitors into loyal customers.
          </p>
        </div>

        <motion.div
          className="wred-benefits-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
        >
          {benefits.map(({ title, text, icon: Icon }) => (
            <motion.article className="wred-benefits-card" variants={fadeUp} key={title}>
              <div className="wred-benefits-card__icon" aria-hidden="true">
                <Icon size={22} strokeWidth={1.75} />
              </div>
              <h3>{title}</h3>
              <p>{text}</p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </div>
  </section>
);

export default WredBenefitsSection;
